// Payment System v3.0 PR 8 — Right-Size workflow API client (design spec
// §8.4). Loan-scoped: POST /api/loans/{id}/right-size/preview and
// POST /api/loans/{id}/right-size.

import { api } from "@/api/client";
import type {
  RightSizeExecuteRequest,
  RightSizeExecuteResponse,
  RightSizePreview,
  RightSizePreviewRequest,
} from "@/types/rightSize";

export const rightSizeApi = {
  preview: (loanId: string, body: RightSizePreviewRequest) =>
    api.post<RightSizePreview>(`/loans/${loanId}/right-size/preview`, body),
  execute: (loanId: string, body: RightSizeExecuteRequest) =>
    api.post<RightSizeExecuteResponse>(`/loans/${loanId}/right-size`, body),
};
